import { Row, Col, Image } from 'react-bootstrap'

import GaugeWhite from '../../../src/assets/VehicleInfo/alert-icons/GaugeWhite.svg'
import GasPump from '../../../src/assets/VehicleInfo/alert-icons/GasPump.svg'
import Truck from '../../../src/assets/VehicleInfo/alert-icons/Truck.svg'
import Warning from '../../assets/VehicleInfo/alert-icons/Warning.svg'
import Engine from '../../assets/VehicleInfo/alert-icons/Engine.svg'
import Package from '../../assets/VehicleInfo/alert-icons/Package.svg'
import Flag from '../../assets/VehicleInfo/alert-icons/Flag.svg'
import HandPalm from '../../assets/VehicleInfo/alert-icons/HandPalm.svg'
import XCircle from '../../assets/VehicleInfo/alert-icons/XCircle.svg'
import StopCircle from '../../assets/VehicleInfo/alert-icons/StopCircle.svg'
import Swap from '../../assets/VehicleInfo/alert-icons/Swap.svg'
import ArrowRight from '../../assets/VehicleInfo/alert-icons/ArrowRight.svg'

import { formatDate } from '../../utils/format'

import styles from './style.module.css'

function RequestHistorical({ reportsInfo }) {
  const reportIconsMap = {
    vehicle_delivered: Flag,
    registered_refuelling: GasPump,
    registered_maintance: Engine,
    registered_maintenance: Engine,
    on_way_to_delivery: Truck,
    request_delivered: Package,
    speeding: GaugeWhite,
    suspicious_activity: Warning,
    traffic_violation: HandPalm,
    request_canceled: XCircle,
    delivery_interrupted: StopCircle,
    request_transfered: Swap,
    on_way_to_internal_transfer: ArrowRight,
  }

  return (
    <Row
      className={`${styles.historicalContainer} border d-flex flex-column justify-content-center align-items-start`}
    >
      {!reportsInfo.length ? (
        <span className={`${styles.infoBadge} text-center`}>Nenhum histórico encontrado</span>
      ) : (
        <div>
          <div style={{ marginLeft: 20, marginTop: 20 }}>
            {reportsInfo?.map((report, index) => (
              <div key={index}>
                <Row>
                  <Col className="col-2 text-center">
                    <Image
                      className={styles.historicIcon}
                      width={50}
                      src={reportIconsMap[report.type]}
                    />
                  </Col>
                  <Col className="col-10 d-flex flex-column align-items-start justify-content-center">
                    <span style={{ fontSize: 12 }}>{formatDate(report.created_at)}</span>
                    <span style={{ fontSize: 18, fontWeight: 'bold' }}>{report.title}</span>
                  </Col>
                </Row>
                <Row>
                  {index !== reportsInfo.length - 1 && (
                    <Col className="col-2 d-flex justify-content-center">
                      <p
                        style={{
                          width: 2,
                          height: '100%',
                          backgroundColor: '#C3C3C3',
                        }}
                      ></p>
                    </Col>
                  )}
                </Row>
              </div>
            ))}
          </div>
        </div>
      )}
    </Row>
  )
}

export default RequestHistorical
